<div class="flex items-center justify-center dialog-header ">
    Move Lead To Group

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">

    <div>
        <div class="mb-1">
            <label for="leadSpaceSelect">Select/Create Lead Group Name</label>
        </div>
        <!-- <p-select id="leadSpaceSelect" appendTo="body" class="w-full" [(ngModel)]="selectedLeadSpace"
            [options]="leadSpaceList">
        </p-select> -->
        <p-autocomplete [(ngModel)]="selectedLeadSpace" [suggestions]="leadSpaceList"
            (completeMethod)="filterSpaceList($event)" optionLabel="label" 
            optionValue="value"
            class="w-full" [style]="{'width':'100%'}"
            appendTo="body" dropdown="true" [multiple]="false">
            <ng-template let-leadSpace #item>
                <div class="flex items-center gap-2">
                    <div>{{ leadSpace.label }}</div>
                </div>
            </ng-template>
            <ng-template #header>
                <div class="font-medium px-3 py-2">Available Lead Space</div>
            </ng-template>
            <ng-template #footer>
                <div class="px-3 py-3">
                    <p-button label="Add New" fluid severity="secondary" text size="small" icon="pi pi-plus"
                        (click)="handleAddNewLeadSpace()" />
                </div>
            </ng-template>
        </p-autocomplete>
    </div>

    <div class="flex justify-end gap-4 mt-7">
        <p-button [label]="'Cancel'" variant="outlined" severity="danger" (click)="handleCloseDialog()"></p-button>
        <p-button [label]="'Move'" [icon]="'pi pi-arrow-right'" (click)="handleMoveLead()"
            [loading]="isLoading"></p-button>

    </div>

</div>


<p-dialog [modal]="true" appendTo="body" [(visible)]="isAddNewSpace"
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">

    <div class="flex items-center justify-center dialog-header ">
        
        Add New Group

        <div class="absolute right-2">
            <button (click)="handleCloseNewLeadSpace()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="p-5">
            <div class="mb-2 font-medium">Enter Group Name</div>
            <input pInputText class="w-full gray-input" [(ngModel)]="newGroupName" />

            <div class="flex justify-end mt-4">
                <div>
                    <p-button label="Create" [loading]="isAddSpaceLoading" (click)="handleAddGroup($event)"
                        [disabled]="!newGroupName || isAddSpaceLoading" icon="pi pi-check" class="w-full mt-4" />
                </div>
            </div>
        </div>
    </div>

</p-dialog>